type TextWithRegisteredMarkProps = {
    text: string;
    className?: string;
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
};

const TextWithRegisteredMark = ({ text, className, as: Tag = "span" }: TextWithRegisteredMarkProps) => {
    if (typeof text !== "string") return text;

    if (!text.includes("®")) {
        return <Tag className={className}>{text}</Tag>;
    }

    return (
        <Tag className={className}>
            {text.split(/(®)/).map((part, index) => {
                return part === "®" ? <sup key={index}>®</sup> : part;
            })}
        </Tag>
    );
};

export default TextWithRegisteredMark;